export enum StatusQuoAnalysisTabEnum {
  DEMAND = 'DEMAND',
  CONSUMPTION = 'CONSUMPTION',
  CLIMATE_RISKS = 'CLIMATE_RISKS',
}

export enum DisplayBaseEnum {
  PER_SQUARE_METER = 'per_square_meter',
  ABSOLUTE = 'absolute',
}

export enum DataCollectionTabActionsEnum {
  CREATE_ENERGY_CERTIFICATE_DRAFT = 'CREATE_ENERGY_CERTIFICATE_DRAFT',
  CREATE_ECONOMIC_UNIT = 'CREATE_ECONOMIC_UNIT',
}

export enum DataCollectionBuildingsTabEnum {
  BUILDINGS = 'BUILDINGS',
  ECONOMIC_UNITS = 'ECONOMIC_UNITS',
  ENERGY_CERTIFICATE_DRAFTS = 'ENERGY_CERTIFICATE_DRAFTS',
}

export enum DataCollectionEnergySuppliersTabEnum {
  ALL = 'ALL',
  VALID = 'VALID',
  EXPIRED = 'EXPIRED',
  DRAFTS = 'DRAFTS',
}

export enum BuildingTabEnum {
  overview = 'overview',
  areas = 'areas',
  consumption = 'consumption',
  buildingModel = 'buildingModel',
  climateRisk = 'climateRisk',
  subsidies = 'subsidies',
  documents = 'documents',
}

/** @deprecated Old tab values kept for backward-compatible URL redirects */
export const LEGACY_BUILDING_TAB_REDIRECTS: Record<string, BuildingTabEnum> = {
  general: BuildingTabEnum.overview,
  digitalTwin: BuildingTabEnum.buildingModel,
  gisImmoRisk: BuildingTabEnum.climateRisk,
};

export enum BuildingSubTabEnum {
  technology = 'technology',
  envelope = 'envelope',
}

export enum ClimateRiskSubTabEnum {
  preCheck = 'preCheck',
  extended = 'extended',
}

export enum ConsumptionHubTabEnum {
  CBI = 'CBI',
  SMART_METERING = 'SMART_METERING',
  MANUAL_ENTRIES = 'MANUAL_ENTRIES',
}

export enum ConsumptionInvoicesTabEnum {
  PROCESSING = 'PROCESSING',
  OVERVIEW = 'OVERVIEW',
  ADDRESSES = 'ADDRESSES',
  DUPLICATES = 'DUPLICATES',
}

export enum ConsumptionDataHubTabEnum {
  // Kebab-case string values so the URL reads
  // `consumptionsTab=manual-entries` instead of the internal-looking
  // `MANUAL_ENTRIES`. The enum names stay screaming-snake for codegen
  // / TypeScript convention.
  COVERAGE = 'coverage',
  INVOICES = 'invoices',
  SMART_METERS = 'smart-meters',
  MANUAL_ENTRIES = 'manual-entries',
  ALL_ENTRIES = 'all-entries',
}

export enum ConsumptionDataHubCoverageViewEnum {
  DASHBOARD = 'DASHBOARD',
  MATRIX = 'MATRIX',
}

export enum ConsumptionDataHubDataTabEnum {
  INVOICES = 'INVOICES',
  SMART_METERS = 'SMART_METERS',
  MANUAL_ENTRIES = 'MANUAL_ENTRIES',
}

export enum ConsumptionDataHubInvoicesSubTabEnum {
  BUILDING_MAPPING = 'BUILDING_MAPPING',
  INVOICES = 'INVOICES',
}

export enum ConsumptionDataHubSmartMetersSubTabEnum {
  BUILDING_MAPPING = 'BUILDING_MAPPING',
  SYNC_HISTORY = 'SYNC_HISTORY',
}

export enum DesignSystemStageEnum {
  ATOMS = 'ATOMS',
  MOLECULES = 'MOLECULES',
  ORGANISMS = 'ORGANISMS',
  TEMPLATES = 'TEMPLATES',
  PAGES = 'PAGES',
}

export enum DesignSystemAtomEnum {
  TYPOGRAPHY = 'TYPOGRAPHY',
  SKELETON = 'SKELETON',
  BUTTON = 'BUTTON',
  ICON_BUTTON = 'ICON_BUTTON',
  POPOVER = 'POPOVER',
}

export enum DesignSystemMoleculeEnum {
  TYPOGRAPHY_LOADING = 'TYPOGRAPHY_LOADING',
  BUTTON_WITH_POPOVER = 'BUTTON_WITH_POPOVER',
  ICON_BUTTON_WITH_POPOVER = 'ICON_BUTTON_WITH_POPOVER',
  BREADCRUMBS = 'BREADCRUMBS',
}

export enum DesignSystemOrganismEnum {
  PAGE_HEADER = 'PAGE_HEADER',
}

export enum PortfolioDisplayViewEnum {
  DASHBOARD = 'dashboard',
  LIST = 'list',
}

export enum ScenariosTabEnum {
  ACTIVE = 'active',
  ARCHIVED = 'archived',
}
